import {
    FOCUS_RING,
    Icon,
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@amelio/ui-library';

import type { ReactNode } from 'react';

interface ObjectiveHelpTooltipProps {
    /** Names the trigger for assistive technology: the icon carries no text of its own. */
    label: string;
    children: ReactNode;
    dataTestId: string;
}

/**
 * A small "i" that explains one thing where that thing is, on hover and on focus.
 *
 * The trigger is a real button rather than the icon alone: it takes focus, so the sentence is
 * reachable from the keyboard and named for assistive technology, on a target wide enough to aim
 * at with a finger.
 */
export default function ObjectiveHelpTooltip({
    label,
    children,
    dataTestId,
}: ObjectiveHelpTooltipProps) {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <button
                        type={'button'}
                        aria-label={label}
                        className={`${FOCUS_RING} text-obj-muted hover:text-navy flex size-[24px] items-center justify-center rounded-full transition-colors`}
                        data-testid={dataTestId}
                    >
                        <Icon
                            name={'essential-info-circle'}
                            size={'md'}
                            color={'inherit'}
                            ariaHidden
                        />
                    </button>
                </TooltipTrigger>

                <TooltipContent className={'max-w-[320px]'}>{children}</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
